import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { queryClient, whenSignedOut } from "./lib/query";
import { listenForInstall } from "./lib/install";
import { ThemeProvider } from "./components/theme";
import "./index.css";

// Before anything renders: Chrome offers installing once, early.
listenForInstall();

// A read answering 401 has emptied the cache: the loaders run again, and the
// guards send the visitor to sign-in.
whenSignedOut(() => void router.revalidate());

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
